// extracted by mini-css-extract-plugin
export default {"privacyBanner":"privacyBanner__PrivacyBanner__gGwvO"};